import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { UiRepository } from 'app/state/ui.repository';
import { MessageService } from 'primeng/api';
import { filter, Subscription } from 'rxjs';

@Component({
    selector: 'app-apphomelayout',
    templateUrl: './apphomelayout.component.html',
    styleUrls: ['./apphomelayout.component.scss'],
    standalone: false
})
export class ApphomelayoutComponent implements OnInit, OnDestroy {
  backgroundColor = '';
  routerSub!: Subscription;
  isAiSellingPage = false;

  constructor(
    public messageService: MessageService,
    public generalDataRepo: GeneralDataRepository,
    public ui: UiRepository,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.updateAiSellingFlag(event.urlAfterRedirects);
      });

    this.updateAiSellingFlag(this.router.url);
  }
  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  updateAiSellingFlag(url: string) {
    const aiSellingPattern = /^\/ai-selling\/[0-9a-fA-F-]{36}(\/.*)?$/;
    this.isAiSellingPage = aiSellingPattern.test(url);
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    let header = document.getElementsByTagName('app-headermenu')[0];
    let main = document.getElementsByTagName('html')[0];

    if (main.scrollTop > 15) {
      header.classList.add('active');
    } else {
      header.classList.remove('active');
    }
  }
}
